import { Image } from 'expo-image';
import * as React from 'react';
import { Pressable, View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import type { Brand } from '@/api/cars/types';
import { Text } from '@/ui';

interface CardBrandProps {
  brand: Brand;
  style?: any;
  disabled?: boolean;
  active?: boolean;
  onPress?: () => void;
  imageStyle?: any;
}

export const CardBrand = ({
  brand,
  style,
  disabled = false,
  active = false,
  onPress,
  imageStyle,
}: CardBrandProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);

  const getStyle = () => {
    const showDisabled = disabled;
    let stateStyle = styles.default;

    if (showDisabled) {
      stateStyle = styles.disabled;
    }
    if (hover) {
      stateStyle = styles.hover;
    }
    if (active) {
      stateStyle = styles.active;
    }

    return [stateStyle];
  };

  return (
    <Pressable
      style={[styles.container, getStyle(), style]}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      hitSlop={8}
      onPress={() => onPress?.()}
    >
      <View
        style={{
          flexGrow: 1,
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <Image
          source={{
            uri:
              UnistylesRuntime.themeName === 'dark'
                ? brand.logos.dark
                : brand.logos.light,
          }}
          style={[styles.image, imageStyle]}
          contentFit="contain"
        />

        <Text type="caption1">{brand.displayName}</Text>
      </View>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    borderRadius: 16,
    padding: 16,
    borderWidth: 1,
  },
  default: {
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderColor: theme.colors.card.default.borderColor,
  },
  active: {
    backgroundColor: theme.colors.card.active.backgroundColor,
    borderColor: theme.colors.card.active.borderColor,
    borderWidth: 1,
  },
  hover: {
    backgroundColor: theme.colors.card.hover.backgroundColor,
    borderColor: theme.colors.card.hover.borderColor,
  },
  disabled: {
    backgroundColor: theme.colors.card.disabled.backgroundColor,
    borderColor: theme.colors.card.disabled.borderColor,
  },
  image: {
    height: {
      xs: 40,
      md: 56,
    },
    width: '100%',
  },
}));
